module.exports = __webpack_public_path__ + "img/upper_pocket_entry_length.a4b55d4d.png";